import React from "react";

// Sticky offline banner shown at the top of the menu page whenever the
// browser reports it's offline. Reassures the guest their cart is safe.
export default function OfflineBanner({ online, t }) {
  if (online) return null;
  return (
    <div
      style={{
        position: "sticky", top: 0, zIndex: 50,
        background: "#7a5c00", color: "#fff",
        padding: "8px 14px", fontSize: 14, textAlign: "center",
        borderRadius: 8, marginBottom: 10,
      }}
    >
      {t("offline_banner")}
    </div>
  );
}
